export const getLocaleCode = (culture) => {
  switch (culture) {
    case "en-US":
      return "en_gb";
    case "sv-SE":
      return "sv";
    case "fi-FI":
      return "fi";
    case "nb-NO":
      return "nb";
    default:
      return "sv";
  }
};
